import {getInstitutionId} from "../app/utilities/helpers.functions";
const institution = getInstitutionId('prod');

export const environment = {
    type: 'prod',
    production: true,
    institutionCode: institution.institutionId,
    cxUrl: institution.cxUrl,
    s3Url: 'https://creditsnap-public.s3.amazonaws.com/',
    debug: false,
    apiUrl:'https://prod-api-elb2.creditsnap.com/csb2b/',
    auth: {
        basic: 'Basic Y3NfdHJ1c3RlZF9jbGllbnRfcHJvZDpqM3JYSkE2UEx5SkVNSm1N',
        scope: 'read write trust',
        grantType: 'password',
        interceptorSkipHeader: 'X-Skip-Interceptor'
    },
};
